<h3 mat-dialog-title>Filtrar Basket</h3>
<div mat-dialog-content style="width: 100%">
    
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">

        <mat-form-field appearance="outline" floatLabel="always" fxFlex="1000">
            <mat-label>Tipo</mat-label>
            <mat-select 
                placeholder="Tipo"
                [formControl]="tipo_id"
                name="tipo_id" >
                <mat-option value="">Selecione...</mat-option>
                <mat-option *ngFor="let tipo of listTipos" [value]="tipo.id">{{tipo.nome}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinner"></mat-spinner>
        </mat-form-field>

    </div>

    <div fxLayout="column" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Rótulo</mat-label>
            <input 
                matInput 
                placeholder="Rótulo"
                name="rotulo"
                [formControl]="rotulo"
                maxlength="100">
        </mat-form-field>
    </div>

    <div fxLayout="column" fxLayout.gt-md="row">
        <mat-form-field appearance="outline" fxLayoutAlign="start" floatLabel="always" fxFlex="45">
            <mat-label>Data da Operação Início</mat-label>
            <input matInput [matDatepicker]="picker" [formControl]="data_operacao_inicio" name="data_operacao_inicio" placeholder="Data da Operação">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline" fxLayoutAlign="end" floatLabel="always" fxFlex="45">
            <mat-label>Data da Operação Fim</mat-label>
            <input matInput [matDatepicker]="pickerFim" [formControl]="data_operacao_fim" name="data_operacao_fim" placeholder="Data da Operação">
            <mat-datepicker-toggle matSuffix [for]="pickerFim"></mat-datepicker-toggle>
            <mat-datepicker #pickerFim></mat-datepicker>
        </mat-form-field>
        
    </div>

</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button (click)="filtrar()" tabindex="-1">Filtrar</button>
</div>